import React from 'react';
import PageSeo from '@/seo/PageSeo';
import ApplyTrial from '../components/SignUp/ApplyTrialPage';

function ApplyTrialPage() {
  return (
    <React.Fragment>
      <PageSeo
        title="Free Trial of the Gene-Disease Association Database | DISGENET"
        description="Apply for a free trial of DISGENET to explore curated gene-disease and variant-disease associations, target identification and API access."
        path="/free-trial-apply"
      />
      <ApplyTrial />
    </React.Fragment>
  );
}

export default ApplyTrialPage;
